const purple = {
  '0': {
    hex: '#fcfcfe',
    css: 'rgb(252,252,254)',
    hsl: 'hsl(240,50%,99.22%)',
    rgb: {
      r: 252,
      g: 252,
      b: 254,
    },
  },
  '10': {
    hex: '#dfe2f3',
    css: 'rgb(223,226,243)',
    hsl: 'hsl(231,45.45%,91.37%)',
    rgb: {
      r: 223,
      g: 226,
      b: 243,
    },
  },
  '20': {
    hex: '#c3c9e8',
    css: 'rgb(195,201,232)',
    hsl: 'hsl(230.27,44.58%,83.73%)',
    rgb: {
      r: 195,
      g: 201,
      b: 232,
    },
  },
  '30': {
    hex: '#a7b0dd',
    css: 'rgb(167,176,221)',
    hsl: 'hsl(230,44.26%,76.08%)',
    rgb: {
      r: 167,
      g: 176,
      b: 221,
    },
  },
  '40': {
    hex: '#8b98d3',
    css: 'rgb(139,152,211)',
    hsl: 'hsl(229.17,45%,68.63%)',
    rgb: {
      r: 139,
      g: 152,
      b: 211,
    },
  },
  '50': {
    hex: '#6e80c7',
    css: 'rgb(110,128,199)',
    hsl: 'hsl(227.87,44.28%,60.59%)',
    rgb: {
      r: 110,
      g: 128,
      b: 199,
    },
  },
  '60': {
    hex: '#5469b4',
    css: 'rgb(84,105,180)',
    hsl: 'hsl(226.88,39.02%,51.76%)',
    rgb: {
      r: 84,
      g: 105,
      b: 180,
    },
  },
  '70': {
    hex: '#3e4e88',
    css: 'rgb(62,78,136)',
    hsl: 'hsl(227.03,37.37%,38.82%)',
    rgb: {
      r: 62,
      g: 78,
      b: 136,
    },
  },
  '80': {
    hex: '#334072',
    css: 'rgb(51,64,114)',
    hsl: 'hsl(227.62,38.18%,32.35%)',
    rgb: {
      r: 51,
      g: 64,
      b: 114,
    },
  },
  '90': {
    hex: '#232d53',
    css: 'rgb(35,45,83)',
    hsl: 'hsl(227.5,40.68%,23.14%)',
    rgb: {
      r: 35,
      g: 45,
      b: 83,
    },
  },
  '100': {
    hex: '#141c36',
    css: 'rgb(20,28,54)',
    hsl: 'hsl(225.88,45.95%,14.51%)',
    rgb: {
      r: 20,
      g: 28,
      b: 54,
    },
  },
  // stops: 11,
  default: {
    hex: '#3e4e88',
    css: 'rgb(62,78,136)',
    hsl: 'hsl(227.03,37.37%,38.82%)',
    rgb: {
      r: 62,
      g: 78,
      b: 136,
    },
  },
  // defaultStop: 70,
};

export default purple;
